import styled from "styled-components";

export const BannersContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(3)};
  width: 100%;

  @media only screen and (max-width: ${({ theme }) => theme.media.breakpoints.lg - 1}px) {
    flex-direction: column;
  }

  & > * {
    flex: 1;
  }
`;
